
export default class Payroll {
  static PaidAs = {
    Contractor: 'Contractor',
    Vendor: 'Vendor',
  }
  static Event = {
    Success: 'Success',
    StudentNoShow: 'StudentNoShow',
    CounselorNoShow: 'CounselorNoShow',
    LateCancel: 'LateCancel',
    Adjustment: 'Adjustment',
    LicenseReimbursement: 'LicenseReimbursement',

    WorkshopFullSuccess: 'WorkshopFullSuccess',
    WorkshopNoSuccess: 'WorkshopNoSuccess',
    WorkshopCounselorNoShow: 'WorkshopCounselorNoShow',
  }
  static GetEventDisplay(event, plural) {
    if (event === Payroll.Event.Success) {
      return plural ? `Successful Sessions` : 'Successful Session'
    } else if (event === Payroll.Event.StudentNoShow) {
      return plural ? `Student No Show Sessions` : 'Student No Show Session'
    } else if (event === Payroll.Event.CounselorNoShow) {
      return plural ? `Counselor No Show Sessions` : 'Counselor No Show Session'
    } else if (event === Payroll.Event.LateCancel) {
      return plural ? `Late Canceled Sessions` : 'Late Canceled Session'
    } else if (event === Payroll.Event.Adjustment) {
      return plural ? `Adjustments` : 'Adjustment'
    } else if (event === Payroll.Event.LicenseReimbursement) {
      return plural ? `License Reimbursements` : 'License Reimbursement'
    } else if (event === Payroll.Event.WorkshopFullSuccess) {
      return plural ? `Successful Workshops` : 'Successful Workshop'
    } else if (event === Payroll.Event.WorkshopCounselorNoShow) {
      return plural ? `Counselor No Show Workshops` : 'Counselor No Show Workshop'
    } else if (event === Payroll.Event.WorkshopNoSuccess) {
      return plural ? `Unattended Workshops` : 'Unattended Workshop'
    } else {
      return event;
    }
  }
}